import { render, staticRenderFns } from "./LeaveSetupGrid.vue?vue&type=template&id=69b94194"
import script from "./LeaveSetupGrid.vue?vue&type=script&lang=js"
export * from "./LeaveSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports